import { PageAuth } from '../model/PageAuth';
import _ from 'lodash';
import { codeDict } from '../constant/authCode';
var AuthBiz = (function () {
    function AuthBiz() {
    }
    AuthBiz.getAuth = function (code, powerKeys) {
        var pageName = AuthBiz.PageCodeDict[code];
        var pageAuth = new PageAuth();
        pageAuth.Name = pageName;
        pageAuth.Code = code;
        for (var key in this.PageAuthDict) {
            var element = this.PageAuthDict[key];
            pageAuth.Auth[element] = powerKeys.indexOf(key) > -1;
        }
        return pageAuth;
    };
    AuthBiz.PageCodeDict = codeDict;
    AuthBiz.PageAuthDict = {
        '101': 'Add',
        '102': 'Delete',
        '103': 'Modify',
        '104': 'LookDetail',
        '105': 'AssignAuth',
        '106': 'Able',
        '107': 'TransferAuth',
        '5001': 'PendingBusiness',
        '5002': 'CerWarn',
        '5003': 'IncomeExpenses',
        '187': 'downLoadPdf',
        '108': 'Print',
        '139': 'LabelPrint',
        '109': 'Export',
        '110': 'Confirm',
        '111': 'SumStock',
        '112': 'Ship',
        '113': 'Up',
        '114': 'Down',
        '115': 'BindGood',
        '116': 'UnbindGood',
        '117': 'TransferClient',
        '118': 'Submit',
        '119': 'ModifyShop',
        '120': 'TransferGood',
        '121': 'Import',
        '122': 'restore',
        '123': 'BulkBind',
        '124': 'BatchEdit',
        '184': 'Audit',
        '125': 'CateManage',
        '126': 'MoreSpec',
        '127': 'AddShop',
        '128': 'DeleteShop',
        '129': 'LookPrice',
        '185': 'ProductMaintenance',
        '186': 'SyncOther',
        '190': 'Handle',
        '300': 'ConfigSave',
        '301': 'DecorationSave',
        '302': 'PurchaseTimeLookDetail',
        '303': 'PurchaseTimeAdd',
        '304': 'PurchaseTimeModify',
        '305': 'PurchaseTimeDelete',
        '172': 'LookRecord',
        '132': 'StoreSplitRules',
        '192': 'PriceDelay',
        '130': 'BindClient',
        '131': 'UnbindClient',
        '133': 'BindLicenses',
        '134': 'UnbindLicenses',
        '135': 'BindSupplier',
        '136': 'SetDefault',
        '137': 'Cancel',
        '138': 'SetDefaultSupplier',
        '180': 'Distribution',
        '181': 'CancelGoods',
        '182': 'Copy',
        '193': 'LookPurchaseOrderForUpperSupDetail',
        '140': 'SendEmail',
        '194': 'Pay',
        '5004': 'ValidityWarning',
        '5005': 'ExceedWarning',
        '5006': 'UnsalableWarning',
        '5007': 'SafeStockWarning',
        '195': 'ProductionDateManage',
        '196': 'WarningManage',
        '197': 'ShowCostAmount',
        '198': 'ShowGrossProfit',
        '199': 'ShowGrossMargin',
        '200': 'SourceCodePrint',
        '201': 'HandleRecharge',
        '202': 'HandleDeduction',
        '601': 'bindStore',
        '151': 'bindSaleMan',
        '203': 'SortingTagPrint',
        '204': 'CreateRefundOrder',
        '205': 'AppointmentDeliveryTime',
        '210': 'ExportList',
        '210015': 'BatchManage',
        '141': 'Reject',
        '212': 'ServiceSetting',
        '211': 'Invoice',
        '602': 'BatchEditOrderInfo',
        '213': 'InitPlateFormSort',
    };
    return AuthBiz;
}());
export { AuthBiz };
export var authNameCodeDict = _.invert(AuthBiz.PageAuthDict);
export default AuthBiz;
